import { useCallback, useEffect, useState } from "react";
import { TfaMethod } from "@/core/constants/tfaMethod";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import {
  enableResetPasswordMethodsSelector,
  resetPasswordMethodSelector,
  setResetPasswordMethod,
} from "@/domains/auth/slice";
import AuthResetPasswordAuthenticatorContainer from "@/domains/auth/containers/reset-password/method/AuthResetPasswordAuthenticatorContainer";
import AuthResetPasswordEmailContainer from "@/domains/auth/containers/reset-password/method/AuthResetPasswordEmailContainer";
import AuthResetPasswordSMSContainer from "@/domains/auth/containers/reset-password/method/AuthResetPasswordSMSContainer";
import AuthTitle from "@/domains/auth/components/AuthTitle";
import AuthResetPassword from "@/domains/auth/components/reset-password/AuthResetPassword";

const methodContainerMap = {
  [TfaMethod.AUTHENTICATOR]: AuthResetPasswordAuthenticatorContainer,
  [TfaMethod.EMAIL]: AuthResetPasswordEmailContainer,
  [TfaMethod.SMS]: AuthResetPasswordSMSContainer,
};

// TODO: дубликат AuthResetPassword
export default function AuthResetPinContainer() {
  // Container
  const dispatch = useAppDispatch();
  const method = useAppSelector(resetPasswordMethodSelector);
  const [currMethod, setCurrMethod] = useState(method);
  const enableResetPasswordMethods = useAppSelector(enableResetPasswordMethodsSelector);

  useEffect(() => {
    setCurrMethod(method);
  }, [method]);

  const onConfirmMethod = useCallback(() => {
    if (!currMethod) return;
    dispatch(setResetPasswordMethod(currMethod));
  }, [dispatch, currMethod]);

  const SelectedMethodContainer = methodContainerMap[method];

  if (SelectedMethodContainer) {
    return <SelectedMethodContainer />;
  }

  return (
    <>
      <AuthTitle back="/auth/sign-in">Восстановление пин-кода</AuthTitle>
      <AuthResetPassword
        currMethod={currMethod}
        enableMethods={enableResetPasswordMethods}
        onChangeMethod={setCurrMethod}
        onSubmit={onConfirmMethod}
      />
    </>
  );
}
